export function LocalStorage(target: Object, propertyName: string) {
	const localStorage = window.localStorage;
	Object.defineProperty(target, propertyName, {
		get: () => window.localStorage.getItem(propertyName),
		set: (value?: any) => value === undefined ? localStorage.removeItem(propertyName) : localStorage.setItem(propertyName, value),
		enumerable: true,
		configurable: true
	});
}
